import { render, staticRenderFns } from "./BeginRedelegateMessageDetails.vue?vue&type=template&id=f97aa7f2&"
import script from "./BeginRedelegateMessageDetails.vue?vue&type=script&lang=js&"
export * from "./BeginRedelegateMessageDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports